// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * NextWork API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AskProject200Response,
  AskProjectRequest,
  Course,
  DocumentCopyRequest,
  DocumentCopyResponse,
  DocumentRef,
  Event,
  ExamplesProject200Response,
  ExamplesProjectRequest,
  ExplainProject200Response,
  ExplainProjectRequest,
  GoalRoadmap,
  GoalUpdate,
  KeyVal,
  Marker,
  NameUpdate,
  PictureUpdate,
  Portfolio,
  PortfolioDocument,
  Preferences,
  Project,
  ProjectSelection,
  ProjectUpdate,
  Quiz,
  QuizAttempt,
  Schedule,
  SearchResults,
  SummarizeProject200Response,
  SummarizeProject400Response,
  SummarizeProjectRequest,
  UserInfo,
  Validation,
  ValidationResponse,
} from '../models/index';
import {
    AskProject200ResponseFromJSON,
    AskProject200ResponseToJSON,
    AskProjectRequestFromJSON,
    AskProjectRequestToJSON,
    CourseFromJSON,
    CourseToJSON,
    DocumentCopyRequestFromJSON,
    DocumentCopyRequestToJSON,
    DocumentCopyResponseFromJSON,
    DocumentCopyResponseToJSON,
    DocumentRefFromJSON,
    DocumentRefToJSON,
    EventFromJSON,
    EventToJSON,
    ExamplesProject200ResponseFromJSON,
    ExamplesProject200ResponseToJSON,
    ExamplesProjectRequestFromJSON,
    ExamplesProjectRequestToJSON,
    ExplainProject200ResponseFromJSON,
    ExplainProject200ResponseToJSON,
    ExplainProjectRequestFromJSON,
    ExplainProjectRequestToJSON,
    GoalRoadmapFromJSON,
    GoalRoadmapToJSON,
    GoalUpdateFromJSON,
    GoalUpdateToJSON,
    KeyValFromJSON,
    KeyValToJSON,
    MarkerFromJSON,
    MarkerToJSON,
    NameUpdateFromJSON,
    NameUpdateToJSON,
    PictureUpdateFromJSON,
    PictureUpdateToJSON,
    PortfolioFromJSON,
    PortfolioToJSON,
    PortfolioDocumentFromJSON,
    PortfolioDocumentToJSON,
    PreferencesFromJSON,
    PreferencesToJSON,
    ProjectFromJSON,
    ProjectToJSON,
    ProjectSelectionFromJSON,
    ProjectSelectionToJSON,
    ProjectUpdateFromJSON,
    ProjectUpdateToJSON,
    QuizFromJSON,
    QuizToJSON,
    QuizAttemptFromJSON,
    QuizAttemptToJSON,
    ScheduleFromJSON,
    ScheduleToJSON,
    SearchResultsFromJSON,
    SearchResultsToJSON,
    SummarizeProject200ResponseFromJSON,
    SummarizeProject200ResponseToJSON,
    SummarizeProject400ResponseFromJSON,
    SummarizeProject400ResponseToJSON,
    SummarizeProjectRequestFromJSON,
    SummarizeProjectRequestToJSON,
    UserInfoFromJSON,
    UserInfoToJSON,
    ValidationFromJSON,
    ValidationToJSON,
    ValidationResponseFromJSON,
    ValidationResponseToJSON,
} from '../models/index';

export interface AskProjectOperationRequest {
    id: string;
    askProjectRequest: AskProjectRequest;
}

export interface CompleteQuizRequest {
    projectId: string;
    quizId: string;
    quizAttempt: QuizAttempt;
}

export interface CopyProjectDocRequest {
    projectId: string;
    documentCopyRequest: DocumentCopyRequest;
}

export interface CreatePortfolioDocumentRequest {
    portfolioDocument: PortfolioDocument;
}

export interface DeletePortfolioDocumentRequest {
    documentId: string;
}

export interface DeleteProjectFileRequest {
    id: string;
    filename: string;
}

export interface ExamplesProjectOperationRequest {
    id: string;
    examplesProjectRequest: ExamplesProjectRequest;
}

export interface ExplainProjectOperationRequest {
    id: string;
    explainProjectRequest: ExplainProjectRequest;
}

export interface GetLockedProjectFileRequest {
    id: string;
    filename: string;
}

export interface GetProjectDocRefsRequest {
    projectId: string;
}

export interface GetProjectFileRequest {
    id: string;
    filename: string;
}

export interface GetProjectTrackMarkersRequest {
    projectId: string;
    trackId: string;
}

export interface GetProjectValidationsRequest {
    projectId: string;
}

export interface GetProjectsRequest {
    selected?: string;
}

export interface GetPublicPortfolioRequest {
    nickname: string;
}

export interface GetQuizRequest {
    projectId: string;
    regenerate?: boolean;
}

export interface GetUserInfoRequest {
    refreshProfile?: boolean;
}

export interface GetUserScheduleRequest {
    daysPerWeek?: number;
    hoursPerDay?: number;
    topics?: Array<string>;
    orderBy?: GetUserScheduleOrderByEnum;
    sortBy?: GetUserScheduleSortByEnum;
}

export interface GetValidationRequest {
    projectId: string;
    validationId: string;
}

export interface RecordEventRequest {
    event: Event;
}

export interface RegenerateProjectDocumentRequest {
    projectId: string;
}

export interface ResetProjectRequest {
    id: string;
}

export interface ResetProjectContentRequest {
    id: string;
}

export interface SearchRequest {
    q?: string;
}

export interface SetUserNameRequest {
    nameUpdate: NameUpdate;
}

export interface SetUserPictureRequest {
    pictureUpdate: PictureUpdate;
}

export interface SetUserPreferencesRequest {
    preferences: Preferences;
}

export interface SetUserVariableRequest {
    keyVal: KeyVal;
}

export interface SubmitProjectUpdateRequest {
    projectId: string;
    projectUpdate: ProjectUpdate;
}

export interface SubmitValidationRequest {
    projectId: string;
    validationId: string;
    validationResponse: ValidationResponse;
}

export interface SummarizeProjectOperationRequest {
    id: string;
    summarizeProjectRequest: SummarizeProjectRequest;
}

export interface UpdateGoalRequest {
    goalUpdate: GoalUpdate;
}

export interface UpdatePortfolioDocumentRequest {
    documentId: string;
    portfolioDocument: PortfolioDocument;
}

export interface UpdateProjectFileRequest {
    id: string;
    filename: string;
    body: Blob;
}

export interface UpdateProjectSelectionRequest {
    projectSelection: Array<ProjectSelection>;
}

export interface UpsertPortfolioRequest {
    portfolio: Portfolio;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Ask a question to a given text.
     */
    async askProjectRaw(requestParameters: AskProjectOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AskProject200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling askProject().'
            );
        }

        if (requestParameters['askProjectRequest'] == null) {
            throw new runtime.RequiredError(
                'askProjectRequest',
                'Required parameter "askProjectRequest" was null or undefined when calling askProject().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/projects/{id}/ask`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AskProjectRequestToJSON(requestParameters['askProjectRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AskProject200ResponseFromJSON(jsonValue));
    }

    /**
     * Ask a question to a given text.
     */
    async askProject(requestParameters: AskProjectOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AskProject200Response> {
        const response = await this.askProjectRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Complete a quiz
     */
    async completeQuizRaw(requestParameters: CompleteQuizRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<QuizAttempt>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling completeQuiz().'
            );
        }

        if (requestParameters['quizId'] == null) {
            throw new runtime.RequiredError(
                'quizId',
                'Required parameter "quizId" was null or undefined when calling completeQuiz().'
            );
        }

        if (requestParameters['quizAttempt'] == null) {
            throw new runtime.RequiredError(
                'quizAttempt',
                'Required parameter "quizAttempt" was null or undefined when calling completeQuiz().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/projects/{project_id}/quiz/{quiz_id}`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters['projectId']))).replace(`{${"quiz_id"}}`, encodeURIComponent(String(requestParameters['quizId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: QuizAttemptToJSON(requestParameters['quizAttempt']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => QuizAttemptFromJSON(jsonValue));
    }

    /**
     * Complete a quiz
     */
    async completeQuiz(requestParameters: CompleteQuizRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<QuizAttempt> {
        const response = await this.completeQuizRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Copy a project doc to user uploads
     */
    async copyProjectDocRaw(requestParameters: CopyProjectDocRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentCopyResponse>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling copyProjectDoc().'
            );
        }

        if (requestParameters['documentCopyRequest'] == null) {
            throw new runtime.RequiredError(
                'documentCopyRequest',
                'Required parameter "documentCopyRequest" was null or undefined when calling copyProjectDoc().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/projects/{project_id}/doc/copy`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DocumentCopyRequestToJSON(requestParameters['documentCopyRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentCopyResponseFromJSON(jsonValue));
    }

    /**
     * Copy a project doc to user uploads
     */
    async copyProjectDoc(requestParameters: CopyProjectDocRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentCopyResponse> {
        const response = await this.copyProjectDocRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new portfolio document
     */
    async createPortfolioDocumentRaw(requestParameters: CreatePortfolioDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortfolioDocument>> {
        if (requestParameters['portfolioDocument'] == null) {
            throw new runtime.RequiredError(
                'portfolioDocument',
                'Required parameter "portfolioDocument" was null or undefined when calling createPortfolioDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/portfolio/documents`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PortfolioDocumentToJSON(requestParameters['portfolioDocument']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortfolioDocumentFromJSON(jsonValue));
    }

    /**
     * Create a new portfolio document
     */
    async createPortfolioDocument(requestParameters: CreatePortfolioDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortfolioDocument> {
        const response = await this.createPortfolioDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a portfolio document
     */
    async deletePortfolioDocumentRaw(requestParameters: DeletePortfolioDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling deletePortfolioDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/portfolio/documents/{documentId}`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters['documentId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a portfolio document
     */
    async deletePortfolioDocument(requestParameters: DeletePortfolioDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePortfolioDocumentRaw(requestParameters, initOverrides);
    }

    /**
     * Delete all portfolio documents
     */
    async deletePortfolioDocumentsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/portfolio/documents`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete all portfolio documents
     */
    async deletePortfolioDocuments(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePortfolioDocumentsRaw(initOverrides);
    }

    /**
     * Delete a project file
     */
    async deleteProjectFileRaw(requestParameters: DeleteProjectFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteProjectFile().'
            );
        }

        if (requestParameters['filename'] == null) {
            throw new runtime.RequiredError(
                'filename',
                'Required parameter "filename" was null or undefined when calling deleteProjectFile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/projects/{id}/{filename}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"filename"}}`, encodeURIComponent(String(requestParameters['filename']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a project file
     */
    async deleteProjectFile(requestParameters: DeleteProjectFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteProjectFileRaw(requestParameters, initOverrides);
    }

    /**
     * Generate examples for the given context
     */
    async examplesProjectRaw(requestParameters: ExamplesProjectOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExamplesProject200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling examplesProject().'
            );
        }

        if (requestParameters['examplesProjectRequest'] == null) {
            throw new runtime.RequiredError(
                'examplesProjectRequest',
                'Required parameter "examplesProjectRequest" was null or undefined when calling examplesProject().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/projects/{id}/examples`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ExamplesProjectRequestToJSON(requestParameters['examplesProjectRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExamplesProject200ResponseFromJSON(jsonValue));
    }

    /**
     * Generate examples for the given context
     */
    async examplesProject(requestParameters: ExamplesProjectOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExamplesProject200Response> {
        const response = await this.examplesProjectRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Explain highlighted text for a project
     */
    async explainProjectRaw(requestParameters: ExplainProjectOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExplainProject200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling explainProject().'
            );
        }

        if (requestParameters['explainProjectRequest'] == null) {
            throw new runtime.RequiredError(
                'explainProjectRequest',
                'Required parameter "explainProjectRequest" was null or undefined when calling explainProject().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/projects/{id}/explain`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ExplainProjectRequestToJSON(requestParameters['explainProjectRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExplainProject200ResponseFromJSON(jsonValue));
    }

    /**
     * Explain highlighted text for a project
     */
    async explainProject(requestParameters: ExplainProjectOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExplainProject200Response> {
        const response = await this.explainProjectRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all courses
     */
    async getCoursesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Course>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/courses`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CourseFromJSON));
    }

    /**
     * Get all courses
     */
    async getCourses(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Course>> {
        const response = await this.getCoursesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get the user goal with suggested roadmap
     */
    async getGoalRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoalRoadmap>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/goals`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GoalRoadmapFromJSON(jsonValue));
    }

    /**
     * Get the user goal with suggested roadmap
     */
    async getGoal(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoalRoadmap> {
        const response = await this.getGoalRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get HTML locked content of a project file
     */
    async getLockedProjectFileRaw(requestParameters: GetLockedProjectFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getLockedProjectFile().'
            );
        }

        if (requestParameters['filename'] == null) {
            throw new runtime.RequiredError(
                'filename',
                'Required parameter "filename" was null or undefined when calling getLockedProjectFile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/projects/{id}/{filename}/unlock`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"filename"}}`, encodeURIComponent(String(requestParameters['filename']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Get HTML locked content of a project file
     */
    async getLockedProjectFile(requestParameters: GetLockedProjectFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getLockedProjectFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a portfolio
     */
    async getPortfolioRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Portfolio>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/portfolio`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortfolioFromJSON(jsonValue));
    }

    /**
     * Get a portfolio
     */
    async getPortfolio(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Portfolio> {
        const response = await this.getPortfolioRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get all portfolio documents
     */
    async getPortfolioDocumentsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PortfolioDocument>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/portfolio/documents`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PortfolioDocumentFromJSON));
    }

    /**
     * Get all portfolio documents
     */
    async getPortfolioDocuments(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PortfolioDocument>> {
        const response = await this.getPortfolioDocumentsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get project documentation references
     */
    async getProjectDocRefsRaw(requestParameters: GetProjectDocRefsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DocumentRef>>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling getProjectDocRefs().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/projects/{project_id}/docs`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DocumentRefFromJSON));
    }

    /**
     * Get project documentation references
     */
    async getProjectDocRefs(requestParameters: GetProjectDocRefsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DocumentRef>> {
        const response = await this.getProjectDocRefsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get HTML content for a project file
     */
    async getProjectFileRaw(requestParameters: GetProjectFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getProjectFile().'
            );
        }

        if (requestParameters['filename'] == null) {
            throw new runtime.RequiredError(
                'filename',
                'Required parameter "filename" was null or undefined when calling getProjectFile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/projects/{id}/{filename}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"filename"}}`, encodeURIComponent(String(requestParameters['filename']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Get HTML content for a project file
     */
    async getProjectFile(requestParameters: GetProjectFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getProjectFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get track markers
     */
    async getProjectTrackMarkersRaw(requestParameters: GetProjectTrackMarkersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Marker>>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling getProjectTrackMarkers().'
            );
        }

        if (requestParameters['trackId'] == null) {
            throw new runtime.RequiredError(
                'trackId',
                'Required parameter "trackId" was null or undefined when calling getProjectTrackMarkers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/projects/{project_id}/tracks/{track_id}/markers`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters['projectId']))).replace(`{${"track_id"}}`, encodeURIComponent(String(requestParameters['trackId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MarkerFromJSON));
    }

    /**
     * Get track markers
     */
    async getProjectTrackMarkers(requestParameters: GetProjectTrackMarkersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Marker>> {
        const response = await this.getProjectTrackMarkersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get project validations
     */
    async getProjectValidationsRaw(requestParameters: GetProjectValidationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Validation>>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling getProjectValidations().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/projects/{project_id}/validations`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ValidationFromJSON));
    }

    /**
     * Get project validations
     */
    async getProjectValidations(requestParameters: GetProjectValidationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Validation>> {
        const response = await this.getProjectValidationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all projects
     */
    async getProjectsRaw(requestParameters: GetProjectsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Project>>> {
        const queryParameters: any = {};

        if (requestParameters['selected'] != null) {
            queryParameters['selected'] = requestParameters['selected'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/projects`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProjectFromJSON));
    }

    /**
     * Get all projects
     */
    async getProjects(requestParameters: GetProjectsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Project>> {
        const response = await this.getProjectsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a public portfolio
     */
    async getPublicPortfolioRaw(requestParameters: GetPublicPortfolioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Portfolio>> {
        if (requestParameters['nickname'] == null) {
            throw new runtime.RequiredError(
                'nickname',
                'Required parameter "nickname" was null or undefined when calling getPublicPortfolio().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/{nickname}/portfolio`.replace(`{${"nickname"}}`, encodeURIComponent(String(requestParameters['nickname']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortfolioFromJSON(jsonValue));
    }

    /**
     * Get a public portfolio
     */
    async getPublicPortfolio(requestParameters: GetPublicPortfolioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Portfolio> {
        const response = await this.getPublicPortfolioRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get quiz for a user
     */
    async getQuizRaw(requestParameters: GetQuizRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Quiz>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling getQuiz().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['regenerate'] != null) {
            queryParameters['regenerate'] = requestParameters['regenerate'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/projects/{project_id}/quiz`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => QuizFromJSON(jsonValue));
    }

    /**
     * Get quiz for a user
     */
    async getQuiz(requestParameters: GetQuizRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Quiz> {
        const response = await this.getQuizRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get current logged in user information
     */
    async getUserInfoRaw(requestParameters: GetUserInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserInfo>> {
        const queryParameters: any = {};

        if (requestParameters['refreshProfile'] != null) {
            queryParameters['refresh_profile'] = requestParameters['refreshProfile'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/user`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserInfoFromJSON(jsonValue));
    }

    /**
     * Get current logged in user information
     */
    async getUserInfo(requestParameters: GetUserInfoRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserInfo> {
        const response = await this.getUserInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get current user preferences
     */
    async getUserPreferencesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Preferences>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/user/preferences`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PreferencesFromJSON(jsonValue));
    }

    /**
     * Get current user preferences
     */
    async getUserPreferences(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Preferences> {
        const response = await this.getUserPreferencesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get current user schedule given their preferences
     */
    async getUserScheduleRaw(requestParameters: GetUserScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Schedule>> {
        const queryParameters: any = {};

        if (requestParameters['daysPerWeek'] != null) {
            queryParameters['daysPerWeek'] = requestParameters['daysPerWeek'];
        }

        if (requestParameters['hoursPerDay'] != null) {
            queryParameters['hoursPerDay'] = requestParameters['hoursPerDay'];
        }

        if (requestParameters['topics'] != null) {
            queryParameters['topics'] = requestParameters['topics'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/schedule`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ScheduleFromJSON(jsonValue));
    }

    /**
     * Get current user schedule given their preferences
     */
    async getUserSchedule(requestParameters: GetUserScheduleRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Schedule> {
        const response = await this.getUserScheduleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a validation response given a project and its id.
     */
    async getValidationRaw(requestParameters: GetValidationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ValidationResponse>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling getValidation().'
            );
        }

        if (requestParameters['validationId'] == null) {
            throw new runtime.RequiredError(
                'validationId',
                'Required parameter "validationId" was null or undefined when calling getValidation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/projects/{project_id}/validations/{validation_id}`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters['projectId']))).replace(`{${"validation_id"}}`, encodeURIComponent(String(requestParameters['validationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ValidationResponseFromJSON(jsonValue));
    }

    /**
     * Get a validation response given a project and its id.
     */
    async getValidation(requestParameters: GetValidationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ValidationResponse> {
        const response = await this.getValidationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * This endpoint accepts generic event data in JSON format.
     * Submit an event
     */
    async recordEventRaw(requestParameters: RecordEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['event'] == null) {
            throw new runtime.RequiredError(
                'event',
                'Required parameter "event" was null or undefined when calling recordEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/events`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EventToJSON(requestParameters['event']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * This endpoint accepts generic event data in JSON format.
     * Submit an event
     */
    async recordEvent(requestParameters: RecordEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.recordEventRaw(requestParameters, initOverrides);
    }

    /**
     * Regenerate the project document.
     */
    async regenerateProjectDocumentRaw(requestParameters: RegenerateProjectDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling regenerateProjectDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/projects/{project_id}/docs/regenerate`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Regenerate the project document.
     */
    async regenerateProjectDocument(requestParameters: RegenerateProjectDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.regenerateProjectDocumentRaw(requestParameters, initOverrides);
    }

    /**
     * Reset a project. This includes content and all validations.
     */
    async resetProjectRaw(requestParameters: ResetProjectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Project>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling resetProject().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/projects/{id}/reset`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProjectFromJSON(jsonValue));
    }

    /**
     * Reset a project. This includes content and all validations.
     */
    async resetProject(requestParameters: ResetProjectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Project> {
        const response = await this.resetProjectRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Reset a project\'s content
     */
    async resetProjectContentRaw(requestParameters: ResetProjectContentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling resetProjectContent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/projects/{id}/reset_content`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Reset a project\'s content
     */
    async resetProjectContent(requestParameters: ResetProjectContentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.resetProjectContentRaw(requestParameters, initOverrides);
    }

    /**
     * Get search results
     */
    async searchRaw(requestParameters: SearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchResults>> {
        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchResultsFromJSON(jsonValue));
    }

    /**
     * Get search results
     */
    async search(requestParameters: SearchRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchResults> {
        const response = await this.searchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Saves or updates the user name
     */
    async setUserNameRaw(requestParameters: SetUserNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserInfo>> {
        if (requestParameters['nameUpdate'] == null) {
            throw new runtime.RequiredError(
                'nameUpdate',
                'Required parameter "nameUpdate" was null or undefined when calling setUserName().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/user/name`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: NameUpdateToJSON(requestParameters['nameUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserInfoFromJSON(jsonValue));
    }

    /**
     * Saves or updates the user name
     */
    async setUserName(requestParameters: SetUserNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserInfo> {
        const response = await this.setUserNameRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Saves or updates the user picture
     */
    async setUserPictureRaw(requestParameters: SetUserPictureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserInfo>> {
        if (requestParameters['pictureUpdate'] == null) {
            throw new runtime.RequiredError(
                'pictureUpdate',
                'Required parameter "pictureUpdate" was null or undefined when calling setUserPicture().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/user/picture`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PictureUpdateToJSON(requestParameters['pictureUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserInfoFromJSON(jsonValue));
    }

    /**
     * Saves or updates the user picture
     */
    async setUserPicture(requestParameters: SetUserPictureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserInfo> {
        const response = await this.setUserPictureRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Saves or updates the user preferences
     */
    async setUserPreferencesRaw(requestParameters: SetUserPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Preferences>> {
        if (requestParameters['preferences'] == null) {
            throw new runtime.RequiredError(
                'preferences',
                'Required parameter "preferences" was null or undefined when calling setUserPreferences().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/user/preferences`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PreferencesToJSON(requestParameters['preferences']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PreferencesFromJSON(jsonValue));
    }

    /**
     * Saves or updates the user preferences
     */
    async setUserPreferences(requestParameters: SetUserPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Preferences> {
        const response = await this.setUserPreferencesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates or updates a user variable
     */
    async setUserVariableRaw(requestParameters: SetUserVariableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<KeyVal>> {
        if (requestParameters['keyVal'] == null) {
            throw new runtime.RequiredError(
                'keyVal',
                'Required parameter "keyVal" was null or undefined when calling setUserVariable().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/user/variables`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: KeyValToJSON(requestParameters['keyVal']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => KeyValFromJSON(jsonValue));
    }

    /**
     * Creates or updates a user variable
     */
    async setUserVariable(requestParameters: SetUserVariableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<KeyVal> {
        const response = await this.setUserVariableRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates (if not exists) a test user and clear all its collections
     */
    async setupTestUserRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/user/test`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Creates (if not exists) a test user and clear all its collections
     */
    async setupTestUser(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setupTestUserRaw(initOverrides);
    }

    /**
     * Submit a user project update.
     */
    async submitProjectUpdateRaw(requestParameters: SubmitProjectUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Project>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling submitProjectUpdate().'
            );
        }

        if (requestParameters['projectUpdate'] == null) {
            throw new runtime.RequiredError(
                'projectUpdate',
                'Required parameter "projectUpdate" was null or undefined when calling submitProjectUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/projects/{project_id}`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ProjectUpdateToJSON(requestParameters['projectUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProjectFromJSON(jsonValue));
    }

    /**
     * Submit a user project update.
     */
    async submitProjectUpdate(requestParameters: SubmitProjectUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Project> {
        const response = await this.submitProjectUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Submit a validation for a project.
     */
    async submitValidationRaw(requestParameters: SubmitValidationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ValidationResponse>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling submitValidation().'
            );
        }

        if (requestParameters['validationId'] == null) {
            throw new runtime.RequiredError(
                'validationId',
                'Required parameter "validationId" was null or undefined when calling submitValidation().'
            );
        }

        if (requestParameters['validationResponse'] == null) {
            throw new runtime.RequiredError(
                'validationResponse',
                'Required parameter "validationResponse" was null or undefined when calling submitValidation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/projects/{project_id}/validations/{validation_id}`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters['projectId']))).replace(`{${"validation_id"}}`, encodeURIComponent(String(requestParameters['validationId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ValidationResponseToJSON(requestParameters['validationResponse']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ValidationResponseFromJSON(jsonValue));
    }

    /**
     * Submit a validation for a project.
     */
    async submitValidation(requestParameters: SubmitValidationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ValidationResponse> {
        const response = await this.submitValidationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Summarize highlighted text for a project
     */
    async summarizeProjectRaw(requestParameters: SummarizeProjectOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SummarizeProject200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling summarizeProject().'
            );
        }

        if (requestParameters['summarizeProjectRequest'] == null) {
            throw new runtime.RequiredError(
                'summarizeProjectRequest',
                'Required parameter "summarizeProjectRequest" was null or undefined when calling summarizeProject().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/projects/{id}/summarize`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SummarizeProjectRequestToJSON(requestParameters['summarizeProjectRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SummarizeProject200ResponseFromJSON(jsonValue));
    }

    /**
     * Summarize highlighted text for a project
     */
    async summarizeProject(requestParameters: SummarizeProjectOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SummarizeProject200Response> {
        const response = await this.summarizeProjectRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update the user goal. Returns the updated goal with suggested roadmap.
     */
    async updateGoalRaw(requestParameters: UpdateGoalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoalRoadmap>> {
        if (requestParameters['goalUpdate'] == null) {
            throw new runtime.RequiredError(
                'goalUpdate',
                'Required parameter "goalUpdate" was null or undefined when calling updateGoal().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/goals`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GoalUpdateToJSON(requestParameters['goalUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GoalRoadmapFromJSON(jsonValue));
    }

    /**
     * Update the user goal. Returns the updated goal with suggested roadmap.
     */
    async updateGoal(requestParameters: UpdateGoalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoalRoadmap> {
        const response = await this.updateGoalRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a portfolio document
     */
    async updatePortfolioDocumentRaw(requestParameters: UpdatePortfolioDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortfolioDocument>> {
        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling updatePortfolioDocument().'
            );
        }

        if (requestParameters['portfolioDocument'] == null) {
            throw new runtime.RequiredError(
                'portfolioDocument',
                'Required parameter "portfolioDocument" was null or undefined when calling updatePortfolioDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/portfolio/documents/{documentId}`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters['documentId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PortfolioDocumentToJSON(requestParameters['portfolioDocument']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortfolioDocumentFromJSON(jsonValue));
    }

    /**
     * Update a portfolio document
     */
    async updatePortfolioDocument(requestParameters: UpdatePortfolioDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortfolioDocument> {
        const response = await this.updatePortfolioDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update the content of a project file
     */
    async updateProjectFileRaw(requestParameters: UpdateProjectFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateProjectFile().'
            );
        }

        if (requestParameters['filename'] == null) {
            throw new runtime.RequiredError(
                'filename',
                'Required parameter "filename" was null or undefined when calling updateProjectFile().'
            );
        }

        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling updateProjectFile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/octet-stream';

        const response = await this.request({
            path: `/projects/{id}/{filename}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"filename"}}`, encodeURIComponent(String(requestParameters['filename']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update the content of a project file
     */
    async updateProjectFile(requestParameters: UpdateProjectFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateProjectFileRaw(requestParameters, initOverrides);
    }

    /**
     * Update the user project selection given a desired state.
     */
    async updateProjectSelectionRaw(requestParameters: UpdateProjectSelectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ProjectSelection>>> {
        if (requestParameters['projectSelection'] == null) {
            throw new runtime.RequiredError(
                'projectSelection',
                'Required parameter "projectSelection" was null or undefined when calling updateProjectSelection().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/projects/selection`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['projectSelection']!.map(ProjectSelectionToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProjectSelectionFromJSON));
    }

    /**
     * Update the user project selection given a desired state.
     */
    async updateProjectSelection(requestParameters: UpdateProjectSelectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ProjectSelection>> {
        const response = await this.updateProjectSelectionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upsert a portfolio
     */
    async upsertPortfolioRaw(requestParameters: UpsertPortfolioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Portfolio>> {
        if (requestParameters['portfolio'] == null) {
            throw new runtime.RequiredError(
                'portfolio',
                'Required parameter "portfolio" was null or undefined when calling upsertPortfolio().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/portfolio`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PortfolioToJSON(requestParameters['portfolio']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortfolioFromJSON(jsonValue));
    }

    /**
     * Upsert a portfolio
     */
    async upsertPortfolio(requestParameters: UpsertPortfolioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Portfolio> {
        const response = await this.upsertPortfolioRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetUserScheduleOrderByEnum = {
    Topics: 'topics',
    Recommended: 'recommended',
    Selection: 'selection'
} as const;
export type GetUserScheduleOrderByEnum = typeof GetUserScheduleOrderByEnum[keyof typeof GetUserScheduleOrderByEnum];
/**
 * @export
 */
export const GetUserScheduleSortByEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetUserScheduleSortByEnum = typeof GetUserScheduleSortByEnum[keyof typeof GetUserScheduleSortByEnum];
